import { render, staticRenderFns } from "./baseregistnoList.vue?vue&type=template&id=c01bb96a&scoped=true"
import script from "./baseregistnoList.vue?vue&type=script&lang=js"
export * from "./baseregistnoList.vue?vue&type=script&lang=js"
import style0 from "./baseregistnoList.vue?vue&type=style&index=0&id=c01bb96a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01bb96a",
  null
  
)

export default component.exports